exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".log_actions{display:block;padding:15pt;background-color:#fff}.log_actions .ui.menu{font-size:.8rem}.log_actions .ui.basic.segment{background-color:#f2f2f2}", "", {"version":3,"sources":["/home/steven/dev/Sporte/sporte2/src/components/reports/UserActions.vue"],"names":[],"mappings":"AACA,aACE,cAAe,AACf,aAAc,AACd,qBAAwB,CACzB,AACD,sBACE,eAAkB,CACnB,AACD,+BACE,wBAA0B,CAC3B","file":"UserActions.vue","sourcesContent":["\n.log_actions {\n  display: block;\n  padding: 15pt;\n  background-color: white;\n}\n.log_actions .ui.menu {\n  font-size: 0.8rem;\n}\n.log_actions .ui.basic.segment {\n  background-color: #F2F2F2;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d5387760","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/reports/UserActions.vue
// module id = 957
// module chunks = 24